import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './SelectField.module.scss';
import classNames from 'classnames';
import Icon from '../Icon/Icon';

const SelectField = ({ placeHolder = 'Select an option', options = [], selected = null, onChange = () => null }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const containerRef = useRef(null);

    const handleOptionSelect = (option) => {
        onChange(option)
        setIsMenuOpen(false);
    };

    const handleOutsideClick = (event) => {
        if (
            containerRef.current &&
            !containerRef.current.contains(event.target)
        ) {
            setIsMenuOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const classes = classNames(styles['SelectField'], {
        [styles['SelectField--Active']]: isMenuOpen,
    });

    return (
        <div className={classes} ref={containerRef}>
            <div
                onClick={toggleMenu}
                className={styles['SelectField__Container']}>
                <div className={styles['SelectField__Input']}>
                    <div className={styles['SelectField__SelectedValue']}>
                        {selected ? options.find(x => x.value == selected).label : placeHolder}
                    </div>
                    <Icon type={'chevron'} />
                </div>
                {isMenuOpen && (
                    <div className={styles['SelectField__Menu']}>
                        <ul>
                            {options.map((option) => (
                                <li
                                    className={styles['SelectField__Option']}
                                    key={option.value}
                                    onClick={() => handleOptionSelect(option)}>
                                    {option.label}
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
            </div>
        </div>
    );
};

SelectField.propTypes = {
    placeHolder: PropTypes.string,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string,
            label: PropTypes.string,
            children: PropTypes.arrayOf(PropTypes.node), // Children components for the option
        })
    ),
};

export default SelectField;
